/* The Velorution Post ad slot — variant pick + click/impression logging.
 *
 * Loaded by snippets/velo-tvp-ad.liquid with a plain script tag, immediately after the
 * markup it operates on. That is deliberate and worth keeping: the script runs
 * synchronously during parse, so the losing variants are gone from the DOM before the
 * browser paints and before layout/velo-letter.liquid queries '.cta' to attach its
 * scroll-in animation. Make this async or defer it and readers see every variant flash up
 * at once, and the winner loses its animation.
 *
 * Nothing here is required for the ad to be readable — the copy and the link are in the
 * HTML. If this file fails, the worst case is that every active variant stays hidden.
 */
(function () {
  'use strict';

  var ENDPOINT = 'https://rjswbjwofjpchkpkyrga.supabase.co/functions/v1/tvp-ad-event';

  /* Sticky assignment: a returning reader keeps the same ad. Flip this to false to
     re-roll on every page view — measures pageview CTR instead of visitor CTR, and stores
     nothing in the browser, which is the setting to use if the ad ever has to run without
     a consent banner. */
  var STICKY = true;

  var VID_KEY = 'velo_vid';
  var VAR_KEY = 'velo_tvpad_variant';

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
      return value;
    } catch (e) {
      /* Private mode, storage disabled, quota. Not worth a broken ad. */
      return null;
    }
  }

  function randomId() {
    try {
      if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
    } catch (e) {}
    return 'x' + Math.random().toString(36).slice(2) + Date.now().toString(36);
  }

  /* One id per browser, so impressions and clicks can be tied together and a single
     enthusiastic reader can't look like a good click-through rate. Random — it identifies
     a browser for counting, and carries nothing about the person. */
  var visitor = STICKY ? store(VID_KEY) : null;
  if (STICKY && !visitor) visitor = store(VID_KEY, randomId());
  if (!visitor) visitor = randomId();

  function pick(keys) {
    if (keys.length === 1) return keys[0];
    if (STICKY) {
      var held = store(VAR_KEY);
      /* Ignore a held variant that has since been drafted or renamed, or the reader would
         be stuck seeing nothing. */
      if (held && keys.indexOf(held) !== -1) return held;
    }
    var chosen = keys[Math.floor(Math.random() * keys.length)];
    if (STICKY) store(VAR_KEY, chosen);
    return chosen;
  }

  function send(event, variant, slot) {
    var body = JSON.stringify({
      event: event,
      variant: variant,
      position: slot,
      path: location.pathname,
      visitor: visitor,
      viewport: window.innerWidth < 768 ? 'mobile' : 'desktop'
    });
    try {
      /* sendBeacon survives the page unload that a click starts; fetch would be cancelled
         mid-flight and clicks would undercount. */
      if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'application/json' }))) return;
    } catch (e) {}
    try {
      fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: body, keepalive: true, mode: 'cors' });
    } catch (e) {}
  }

  function activate(box) {
    box.setAttribute('data-tvpad-done', '');

    var cards = [].slice.call(box.querySelectorAll('[data-tvpad-variant]'));
    if (!cards.length) return;

    var keys = cards.map(function (c) { return c.getAttribute('data-tvpad-variant'); });
    var winner = pick(keys);
    var slot = box.getAttribute('data-tvpad-slot') || 'body';
    var card = null;

    cards.forEach(function (c) {
      if (c.getAttribute('data-tvpad-variant') === winner && !card) {
        card = c;
      } else {
        c.parentNode.removeChild(c);
      }
    });
    if (!card) return;

    /* Only the winner's image is ever fetched — the losers' URLs sit in data-tvpad-src so
       running four variants doesn't cost four image downloads. */
    var img = card.querySelector('[data-tvpad-src]');
    if (img) {
      img.src = img.getAttribute('data-tvpad-src');
      img.removeAttribute('data-tvpad-src');
    }

    card.hidden = false;
    box.setAttribute('data-tvpad-ready', '');

    /* An impression is the ad actually being looked at — half of it on screen for a
       second. Counting one per page load instead would inflate the denominator with ads
       nobody scrolled to, and CTR is the whole point of this. */
    var counted = false;
    function count() {
      if (counted) return;
      counted = true;
      send('impression', winner, slot);
    }
    if (window.IntersectionObserver) {
      var timer = null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!timer) timer = setTimeout(function () { count(); io.disconnect(); }, 1000);
          } else if (timer) {
            clearTimeout(timer);
            timer = null;
          }
        });
      }, { threshold: 0.5 });
      io.observe(card);
    } else {
      count();
    }

    var cta = card.querySelector('[data-tvpad-cta]');
    if (cta) {
      cta.addEventListener('click', function () {
        /* No preventDefault and no waiting on the response: the reader goes to the Post
           page at full speed whether or not the logging call lands. */
        if (!counted) count();
        send('click', winner, slot);
      });
    }
  }

  [].slice.call(document.querySelectorAll('[data-tvpad]:not([data-tvpad-done])')).forEach(activate);
})();
